import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'Institutional blurb',
    defaultMessage: 'Institutional blurb',
  },
  contentFieldset: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  items: {
    id: 'Organisations',
    defaultMessage: 'Organisations',
  },
  item: {
    id: 'Organisation',
    defaultMessage: 'Organisation',
  },
  heading: {
    id: 'Organisation heading',
    defaultMessage: 'Heading',
  },
  text: {
    id: 'Organisation text',
    defaultMessage: 'Text',
  },
});

/**
 * Um parceiro da faixa ("Sobre a Década do Oceano:", "Sobre a COI:"…).
 *
 * `text` é `richtext` (HtmlSlateWidget) e não `textarea` pelo mesmo motivo das
 * respostas do FAQ: os blurbs reais têm links e mais de um parágrafo.
 *
 * ⚠️ SEM `default` aqui, de propósito. `applySchemaDefaults` termina num
 * `merge()` do lodash, que combina arrays índice a índice — um `default` com 3
 * itens vira um PISO: apagar um parceiro faz ele ressuscitar no próximo render,
 * e a lista nunca desce abaixo de 3. Como o conteúdo "depende dos parceiros
 * envolvidos", o editor precisa poder remover. Medido num spike em 2026-09-09;
 * o conteúdo inicial vem materializado (ver defaultItems.ts).
 */
export const InstitutionalBlurbItemSchema = ({
  intl,
}: {
  intl: IntlShape;
}) => ({
  title: intl.formatMessage(messages.item),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['heading', 'text'],
    },
  ],
  properties: {
    heading: {
      title: intl.formatMessage(messages.heading),
      type: 'string',
    },
    text: {
      title: intl.formatMessage(messages.text),
      widget: 'richtext',
    },
  },
  required: [],
});

const InstitutionalBlurbSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.contentFieldset),
      fields: ['items'],
    },
  ],
  properties: {
    items: {
      title: intl.formatMessage(messages.items),
      widget: 'object_list',
      schema: InstitutionalBlurbItemSchema({ intl }),
    },
  },
  required: [],
});

export default InstitutionalBlurbSchema;
